module.exports = __webpack_public_path__ + "media/theme/zigzag--sp--black-1eb660fd.png";